
const preventRange = (val) => {
  if (val < 0) return preventRange(360 + val)
  if (val > 360) return preventRange(360 - val)
  return val
}

export default preventRange